import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import Form, { StateInterface, FormValues } from './Form';

import { AppState } from '../../../../store';
import { authenticationAttempt as authenticate } from '../../../../store/user/actions';

interface StateProps {
  readonly error: boolean;
  readonly loading: boolean;
}

interface DispatchProps {
  readonly authenticationAttempt: Function;
}

interface ComponentProps {
  previousState: StateInterface;
}

type Props = ComponentProps & StateProps & DispatchProps;

const FormContainer: React.FC<Props> = ({ error, loading, authenticationAttempt }: Props) => {
  const history = useHistory();

  const handleSubmit = (data: FormValues): void => {
    try {
      history.push('/')
      authenticationAttempt(data.username, data.password, history);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  return <Form onSubmit={handleSubmit} error={error} loading={loading} />;
};

const mapStateToProps = ({ user }: AppState): StateProps => ({
  loading: user.loading,
  error: user.error,
});

const mapDispatchToProps = {
  authenticationAttempt: authenticate,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
